import { CreateInstance } from "./config"
const ConnAPI = CreateInstance("conn")
export default ConnAPI
